var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n    User icon\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 .3h39.7V40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1824 -20)",
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1824 20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.85 1.504c10.281 0 18.646 8.365 18.646 18.646a18.62 18.62 0 01-4.357 11.983 15.369 15.369 0 00-9.246-8.775 8.922 8.922 0 01-5.043 1.557 8.924 8.924 0 01-5.043-1.557 15.368 15.368 0 00-9.247 8.774A18.617 18.617 0 011.203 20.15C1.203 9.87 9.568 1.504 19.85 1.504m0-1.203C8.904.3 0 9.205 0 20.15c0 5.037 1.894 9.848 5.335 13.547a19.955 19.955 0 0014.426 6.3l.089.002a19.956 19.956 0 0014.515-6.303A19.833 19.833 0 0039.7 20.15C39.7 9.205 30.795.3 19.85.3",
    fill: "#000",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1844.5 28a7.5 7.5 0 110 15 7.5 7.5 0 010-15",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.0a0e8a8ac015422bb6889ae2858c0d3d.svg";
export { ForwardRef as ReactComponent };